import type { InferOutput } from 'valibot'
import defu from 'defu'
import { array, nullish, number, object, parse, picklist, string } from 'valibot'

const schema = object({
  uuid: uuidSchema,
  renewAt: nullish(string()),
  startAt: string(),
  cartItem: nullish(cartItemDtoSchema),
  customerOriginId: nullish(string()),
  initialPrice: number(),
  recurringPrice: number(),
  // FIXME: This is just to appease TypeScript ATM. This field will currently not exist, but in the future it (or something similar) should.
  cancelledAt: nullish(string()),

  productId: nullish(string()),
  productName: nullish(string()),
  productSource: nullish(productSourceSchema),
  quantity: nullish(number()),
  status: nullish(picklist(['NEW', 'ACTIVE', 'CANCELLED', 'RENEWED'])),
})

export type Subscription = InferOutput<typeof schema>

function useSubscriptionQueryOptions() {
  const { $coreApi } = useNuxtApp()
  const { loggedIn, user } = useUserSession()

  // eslint-disable-next-line @tanstack/query/exhaustive-deps -- $coreApi is a stable Nuxt-provided fetch wrapper, not a real dep
  return queryOptions({
    queryKey: [user.value?.userId, 'subscriptions'],
    enabled: loggedIn,
    async queryFn({ signal }) {
      const res = await $coreApi.ecommerce('/subscriptions', { signal })
      return parse(array(schema), res)
    },
  })
}

type QueryOptions = ReturnType<typeof useSubscriptionQueryOptions>

export function useSubscriptions(options?: Partial<QueryOptions>) {
  const initialOptions = useSubscriptionQueryOptions()

  const resolvedOptions = computed(() => defu<QueryOptions, [QueryOptions]>(options, initialOptions))

  return useQuery(resolvedOptions.value)
}
